import { gql } from 'graphql-tag';
import ImageSummaryFragment from '@fragments/summaries/ImageSummaryFragment';

export default gql`
    fragment ProjectsSummaryFragment on Project {
        path
        title
        dek
        heroProgramsProjects {
            heroImage {
                ...ImageSummaryFragment
            }
            mobileHeroImage {
                ...ImageSummaryFragment
            }
            logo {
                ...ImageSummaryFragment
            }
        }
    }
    ${ImageSummaryFragment}
`;
